import styled from 'styled-components'

export const RecommendedArticles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`

export const ArticlesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  z-index: 0;

  a {
    text-decoration: none;
  }
  @media (max-width: 1200px) {
    gap: 40px;
  }

  @media (max-width: 1040px) {
    gap: 10px;
  }
`
